/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ListIdRouteImport } from './routes/$listId'
import { Route as IndexRouteImport } from './routes/index'

const ListIdRoute = ListIdRouteImport.update({
  id: '/$listId',
  path: '/$listId',
  getParentRoute: () => rootRouteImport,
})
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
})

const rootRouteChildren = {
  IndexRoute: IndexRoute,
  ListIdRoute: ListIdRoute,
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)
